import React from 'react';
import { ShiftCard } from './ShiftCard';
import { RequestTypes, ShiftSegmentTypeName } from '../../../Enums';
import { formatDateRange, getAsLongDate, getAsStartAndEndTimeFormat } from '../../../../common-client2/src/services/ukgDateTime';

const getShiftCardColorClass = (actionType, isApproved) => {
    switch (actionType) {
        case RequestTypes.toCover:
            return 'to-cover';
        case RequestTypes.shiftSwap:
            return 'shift-swap';
        case RequestTypes.openShift:
            return isApproved ? 'open-shift-approved' : 'open-shift';
        case RequestTypes.voluntaryTimeOff:
            return isApproved ? 'voluntary-time-off-approved' : 'voluntary-time-off';
        default:
            return '';
    }
};

export const ShiftCardInfo = ({
    actionType,
    employeeName,
    employeeNumber,
    isApproved,
    isPartial,
    shiftDescription,
    shiftDetails = {},
    showDatesOnly = false,
}) => {
    const { startDateTime, endDateTime, segments } = shiftDetails;

    const hasTransfer = segments?.some(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
    let shiftLabel = '';
    if (showDatesOnly) {
        shiftLabel = (!!startDateTime && !!endDateTime)
            ? `${shiftDetails.label ?? ""} ${getAsStartAndEndTimeFormat(startDateTime, endDateTime)}`
            : shiftDetails;
    }
    else {
        shiftLabel = (!!startDateTime && !!endDateTime)
            ? `${shiftDetails.label ?? ""} ${getAsStartAndEndTimeFormat(startDateTime, endDateTime)} (${getAsLongDate(startDateTime)})`
            : shiftDetails;
    }

    return (
        <ShiftCard
            employeeName={employeeName}
            employeeNumber={employeeNumber}
            shiftLabel={shiftLabel}
            shiftDescription={shiftDescription}
            shiftCardColorClass={getShiftCardColorClass(actionType, isApproved)}
            hasTransfer={hasTransfer}
            isPartial={isPartial}
        />
    );
};
